import { SearchQuery } from "shared/data/reducers/types/storage";
import { HotelOfferDetail } from "shared/types/hotels";

const filterHotelStars = (searchQuery: SearchQuery) => (
  hotelOffer: HotelOfferDetail
): boolean => {
  if (!searchQuery.stars || searchQuery.stars.length === 0) {
    return true;
  }

  if (!hotelOffer?.HotelDescription.Stars) {
    return false;
  }

  return searchQuery.stars.includes(hotelOffer.HotelDescription.Stars);
};

export default filterHotelStars;
